module.exports = __webpack_public_path__ + "img/email.bdda1675.svg";